/**
 * 调转规则页面配置
 */
export default {
  title: 'Reschedule/Transfer Rules',
  content: `
    <p>If you feel that the level of difficulty, class time, or the course tutor are not to your satisfaction after signing up, you can request to transfer either a specific class or an entire maths course.</p>
    <p>Please find the terms and conditions outlined below:</p>

    <ol>
      <li>Your child may only transfer between courses in the same term (e.g. Spring Term), or maths course with the same number of classes remaining.</li>
      <li>We can only transfer your child to a course with the same RRP (i.e. the listed price of each maths course, irrespective of the original purchase price and discounts applied, etc.). 
      Class and course transfers will not affect your order information; however, we cannot refund nor compensate course transfers if the price of the new course is lower or higher than the original price paid. 
      If the class/course you wish to transfer to is not transferable, please request a refund for the original maths course and register to a new course.</li> 
      <li>We cannot process a course transfer request if requested less than 30 minutes before your child's class is due to begin.</li>
      <li>Once we have completed the transfer request, you can still view class video content and materials from your child's original course via the Think Academy Student app.</li>
    </ol>
  `,
}
